import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import { blogs } from 'src/assets/blogs';
import { _ } from 'underscore';
import { Title, Meta } from '@angular/platform-browser';
import {
  HttpClient,
  HttpResponse,
  HttpParams,
  HttpHeaders,
} from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-hg-blogs',
  templateUrl: './hg-blogs.component.html',
  styleUrls: ['./hg-blogs.component.css'],
})
export class HgBlogsComponent implements OnInit {
  articleCount;
  blogsList = [];
  constructor(
    private router: Router,
    private residentialService: ResidentialService,
    private title: Title,
    private meta: Meta,
    private http: HttpClient
  ) {
    this.blogsList = blogs;
  }
  userObj = {
    emailId: '',
  };
  msg;
  timer;
  time = 3000;
  getSearchedtag = false;
  message;
  // API Url
  url = environment.api_url;

  ngOnInit() {
    this.residentialService.currentMessage.subscribe((msg) => {
      if (!_.isEmpty(msg) && !_.isEmpty(msg['tag'])) {
        this.getSearchedtag = true;
        this.message = msg;
      }
    });
    this.title.setTitle(
      'Honest Gorilla Blog | Stories About Homes, Living and Energy'
    );
    this.meta.updateTag({
      name: 'keywords',
      content:
        ' news, insights, homes, happy living, energy efficiency, energy saving tip, conservation, living on a budget, buying a home, renting a home, renting an apartment, rent, lease, leasing an apartment, leasing a home, energy companies',
    });
    this.meta.updateTag({
      name: 'description',
      content:
        'The Honest Gorilla Blog features insights about homes, living and energy. We explore these topics through the framework of getting ahead in life, sustainably.',
    });
    this.meta.updateTag({ name: 'author', content: 'HonestGorilla' });
    this.meta.updateTag({ name: 'robots', content: 'index, follow' });
  }

  // form validation
  createAccount(event, myForm, formValid) {
    if (formValid) {
      if (myForm.form.value.email) {
        // To send the email for user for Exoiry Contract.
        var EST = new Date();
        EST.setHours(EST.getHours() + 12);
        EST.setMinutes(EST.getMinutes() + 30);
        var date = new Date();

        const userResponses = {
          EmailId: myForm.form.value.email,
          subscribedDate:
            (date.getMonth() > 8
              ? date.getMonth() + 1
              : '0' + (date.getMonth() + 1)) +
            '/' +
            (date.getDate() > 9 ? date.getDate() : '0' + date.getDate()) +
            '/' +
            date.getFullYear(),
          subscribedTime: EST.toLocaleTimeString(),
        };
        const emailbody = new HttpParams().append(
          'emailbody',
          JSON.stringify(userResponses)
        );
        this.http
          .post(this.url + '/blog/subscription', emailbody)
          .subscribe((notifyres: any) => {
            const result = notifyres ? notifyres : '';
            if (result && result.statusCode === '002') {
            } else {
              myForm.resetForm();
            }
          });
      }
      clearTimeout(this.timer);
      this.msg = 'Subscribed.';
      this.timer = setInterval(() => {
        this.msg = '';
      }, this.time);
    }
  }

  // search bar process
  searchBar(e) {
    const searchBarId = <HTMLInputElement>document.getElementById('myInput');
    const uppercaseValues = searchBarId.value.toUpperCase();
    this.showSerched(searchBarId.value);
  }

  showSerched(searchBarId) {
    const searchBarInput = <HTMLInputElement>document.getElementById('myInput');
    searchBarInput.value = searchBarId;
    const cardValues = document.getElementById('myUL');
    const cardValuesProcess = cardValues.getElementsByClassName('card-body');
    for (let i = 0; i < cardValuesProcess.length; i++) {
      const cardVal = <HTMLInputElement>(
        cardValuesProcess[i].getElementsByClassName('tags-group')[0]
      );
      const txtValueLength = cardVal.children.length;
      for (let j = 0; j < txtValueLength; j++) {
        const tagProcess = cardVal.children[j].textContent;
        if (tagProcess.toLowerCase().includes(searchBarId.toLowerCase())) {
          cardVal.parentElement.parentElement.parentElement.style.display = '';
          break;
        } else {
          cardVal.parentElement.parentElement.parentElement.style.display =
            'none';
        }
      }
    }
  }

  articleNavigate(position) {
    if (position == 1) {
      this.title.setTitle(
        'If you’re not doing these 4 things to save energy, you’re burning money'
      );
      this.meta.updateTag({
        name: 'keywords',
        content:
          'save money,save energy,energy efficiency,green,renewables,lighting,led,lights,CFL,Edison bulb,thermostat,smart home,nest,ecobee,replace your air filter,replace your furnace filter',
      });
      this.meta.updateTag({
        name: 'description',
        content:
          'Going green is really about saving green. Whether your motivation is to save money or the environment, with this short list of 4, everyone’s a winner.',
      });
      this.meta.updateTag({ name: 'author', content: 'HonestGorilla' });
      this.meta.updateTag({ name: 'robots', content: 'index, follow' });
      position = 'if-youre-not-saving-energy-youre-burning-money';
    } else if (position == 2) {
      this.title.setTitle(
        'Why everyone has been shopping for energy the wrong way'
      );
      this.meta.updateTag({
        name: 'keywords',
        content:
          'txu,reliant,nrg,green mountain,griddy,recommendation,energy saving tip,customer loyalty,saving green,going green,Texas,energy company,light company,living on a budget,frontier energy,power to choose,compare power companies,choose energy companies,change your thermostat,smart thermostat,smart home,smart appliances,living on a budget,burning money',
      });
      this.meta.updateTag({
        name: 'description',
        content:
          'Shopping for energy can be confusing, and unless you know what you’re looking for, it can be a costly proposition if you make the wrong decision. Learn how to effectively shop for a cheaper plan.',
      });
      this.meta.updateTag({ name: 'author', content: 'HonestGorilla' });
      this.meta.updateTag({ name: 'robots', content: 'index, follow' });
      position =
        'why-you-shouldn’t-trust-anyones-recommendation-when-it-comes-to-this-one-thing';
    } else if (position == 3) {
      this.title.setTitle(
        'Is your AC or Heater Constantly Running? Do These 4 Things And Start Saving'
      );
      this.meta.updateTag({
        name: 'keywords',
        content:
          'window draft,thermostat,window,energy efficiency,shades,blinds,insulation,attic vent,attic tent,solar attic fan,hvac,electricity,energy,weather stripping,draft stopper,outlet draft sealer',
      });
      this.meta.updateTag({
        name: 'description',
        content:
          'Heating or cooling the air inside your home can be costly. We discuss 4 ways you can defy nature and take control over your conditioned air.',
      });
      this.meta.updateTag({ name: 'author', content: 'HonestGorilla' });
      this.meta.updateTag({ name: 'robots', content: 'index, follow' });
      position = 'your-home-as-a-fortress-for-wellbeing';
    } else if (position == 4) {
      this.title.setTitle(
        'Before Renting an Apartment, Here are 3 Things You Need to Know'
      );
      this.meta.updateTag({
        name: 'keywords',
        content:
          'renting,apartments,moving,coffeeshops,dating,rent,electricity,bills,real estate agent,lease,leasing,movers,utilities,epic life,best life,apartment locator,apartment locating,budget',
      });
      this.meta.updateTag({
        name: 'description',
        content:
          'Whether you’re already renting an apartment or planning to make your next move, here are some thoughts on how to make your search a little less stressful.',
      });
      this.meta.updateTag({ name: 'author', content: 'HonestGorilla' });
      this.meta.updateTag({ name: 'robots', content: 'index, follow' });
      position = '3-things-you-need-to-know-before-renting-an-apartment';
    }
    this.articleCount = position;
    this.router.navigate(['/blog/', position]);
    this.residentialService.setArticleFlag({ articleNum: this.articleCount });
  }

  ngAfterViewChecked(): void {
    if (this.getSearchedtag) {
      this.showSerched(this.message['tag']);
      this.getSearchedtag = false;
    }
  }
}
